var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icofont/submit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Zeplin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Specs"
  }, /*#__PURE__*/React.createElement("g", {
    id: "elements-/-chat-/-nino-image",
    filter: ""
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C31.045695,0 40,8.954305 40,20 C40,31.045695 31.045695,40 20,40 C8.954305,40 0,31.045695 0,20 C0,8.954305 8.954305,0 20,0 Z M26.8191536,12.4037783 L10.2021443,18.414186 L10.09945,18.4570776 C9.21567112,18.8791311 9.42118365,20.2466693 10.4420332,20.3495248 L19.2651496,21.2382947 L20.1539195,30.0614111 C20.2605844,31.1200698 21.7273472,31.3018779 22.0892583,30.3013 L28.0996659,13.6842906 C28.3879482,12.887275 27.6161693,12.1154961 26.8191536,12.4037783 Z M25.4933461,15.0100981 L21.7032538,25.4880064 L21.1729968,20.2251628 L21.1520777,20.098788 C21.0565111,19.6868539 20.7082768,19.3737715 20.2782814,19.3304475 L15.0147307,18.7994834 L25.4933461,15.0100981 Z",
    id: "Combined-Shape",
    fill: "#e20613"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmit);
export default __webpack_public_path__ + "static/media/submit.0b6509d2.svg";
export { ForwardRef as ReactComponent };